'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.fonts.add', [])
  .controller('FontsAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/fonts/add/index.js